import React, { useState, useEffect } from 'react'
import { Box, TextInput, Button, Group, Flex } from '@mantine/core'
import { addIndustries, updateIndustries } from '../../../services/industries'
import { validation } from '../../../plugins/validation'
import { notificationSuccess, notificationError } from '../../../components/ui/Notifications'

const defaultVal = {
  name: ''
}

const formValidation = {
  name: {
    isError: false,
    message: ''
  }
}

const FormIndustries = ({ dataIndustries, onCloseModal, reloadList }) => {
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  useEffect(() => {
    if (dataIndustries !== null) {
      handleSetForm(dataIndustries)
    }
  }, [dataIndustries])

  const handleSetForm = (dataIndustries) => {
    const dataDetail = {
      id: dataIndustries.id,
      name: dataIndustries.name,
    }
    setFormData(dataDetail)
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const submitIndustries = async (payloadIndustries) => {
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''
    setLoadingForm(true)
    setValidationForm(formValidation)
    const payload = {
      name: payloadIndustries.name
    }
    const isError = validation(payload, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    if (dataIndustries !== null) {
      methodFunction = updateIndustries(payloadIndustries.id, payload)
      titleMessageSuccess = 'Update Kategori Industri Berhasil'
      captionMessageSuccess = 'Anda telah berhasil mengupdate kategori industri'
      titleMessageError = 'Gagal Mengupdate Kategori Industri'
      captionMessageError = 'Silahkan cek kembali form anda'
    } else {
      methodFunction = addIndustries(payload)
      titleMessageSuccess = 'Tambah Kategori Industri Berhasil'
      captionMessageSuccess = 'Anda telah berhasil menambahkan kategori industri baru'
      titleMessageError = 'Gagal Menambahkan Kategori Industri'
      captionMessageError = 'Silahkan cek kembali form anda'
    }
    try {
      const response = await methodFunction
      if (response) {
        onCloseModal()
        reloadList()
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      notificationError(titleMessageError, `${Object.keys(errorMessage) ? errorMessage : captionMessageError}`)
      Object.values(errorMessage).forEach((el) => {
        Object.keys(formValidation).forEach((element) => {
          if (el.includes(element)) {
            setValidationForm((old) => ({
              ...old,
              [element]: {
                ...old?.[element],
                isError: true,
                message: el
              }
            }))
          }
        })
      })
    } finally {
      setLoadingForm(false)
    }
  }

  return (
    <Box>
      <Box mb='md'>
        <TextInput
          name='name'
          value={formData.name}
          label='Nama Sektor Perusahaan'
          placeholder='Masukkan nama sektor perusahaan'
          error={validationForm.name.isError ? `${validationForm.name.message}` : ''}
          onChange={handleChange}
          withAsterisk
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button variant="outline" color='indigo.9' onClick={onCloseModal}>Tutup</Button>
            <Button loading={loadingForm} variant="filled" color='indigo.9' onClick={() => submitIndustries(formData)}>{dataIndustries === null ? 'Tambah' : 'Update'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormIndustries